<template>
  <div class="mx-2">
    <font-awesome-icon icon="exclamation-triangle"
                       class="text-md text-red"
                       v-tooltip="{ content: hint, classes: '--white' }"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "TransferReceivedHint",
  props: {
    sum: {
      type: [Number, String],
      required: true
    },
    currency: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    hint() {
      const formatted = this.displayCurrencyValue(Number(this.sum), this.currency);
      return `${this.$t('received')} ${formatted}`;
    }
  },
  i18n: {
    messages: {
      en: {
        received: 'Received on account:'
      },
      ru: {
        received: 'Поступило на счет:'
      }
    }
  }
}
</script>
